/** Angular */
import { Subscription } from 'rxjs';
/** Services */
import { BydTranslateService } from '../services/byd-translate.service';

/**
 * The Beyond translate function that will be executed when the application is initialized.
 *
 * @param bydTranslateService the beyond translate service
 * @returns Observable
 */
export function bydTranslateInitializer(bydTranslateService: BydTranslateService): () => Subscription {
  return () => bydTranslateService.use().subscribe();
}
